export default function isHTMLResponse(type) {
  if (typeof type === 'string') {
    return type.indexOf('text/html') > -1;
  } else {
    return false;
  }
}